import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'

import Modal from './Modal'
import ModalHeader from './ModalHeader'
import ModalBody from './ModalBody'
import ModalFooter from './ModalFooter'

import { List } from 'immutable'

import {
    hideModalSelectorAirport,
    getDataFromUrlAirports,
    clearPagesModalSelectorAirport
} from '../../actions/common'

import { addTitleIfOverflow } from '../../utils/helpers'

const WAIT_INTERVAL = 1000
const ENTER_KEY = 13

class ModalSelectorAirport extends Component {
    constructor(props) {
        super(props)

        this.state = {
            value: props.modalSelectorAirport.get('filter')
        }
    }

    handleCloseModal = (e) => {
        const modal = document.getElementById('modalSelectorAirport')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#modalSelectorAirport .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        setTimeout(() => {
            this.props.hideModalSelectorAirport(false)
            this.setState({ value: '' })
        }, 300)
    }

    handleSelectFromSelector = (e, obj) => {
        this.props.modalSelectorAirport.get('action')(obj, this.state.value)
        this.setState({ value: '' })
        this.props.hideModalSelectorAirport()
    }

    handleOnChange = (value) => {
        clearTimeout(this.timer)
        this.setState({ value })
        this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
    }

    handleOnKeyDown = (key) => {
        if (key === ENTER_KEY) {
            clearTimeout(this.timer)
            this.triggerChange()
        }
    }

    triggerChange = () => {
        this.props.clearPagesModalSelectorAirport()
        this.props.getDataFromUrlAirports(this.state.value)
    }

    render() {
        const { modalSelectorAirport } = this.props
        const seachingAirports = modalSelectorAirport.get('isLoading')
        
        if (modalSelectorAirport.get('show') === false) return null
        
        return (
            <Modal id="modalSelectorAirport" show={ true } ZIndex={ 2001 }>
                <ModalHeader title={ modalSelectorAirport.get('title') } onClose={ (e) => this.handleCloseModal(e, "modalSelectorAirport") } />
                <ModalBody>
                    <div style={{ width: '400px' }}>
                        <div className="row">
                            <div className="col-lg-12">
                                <div style={{ marginBottom: '10px' }}>
                                    <input className="form-control input-sm" type="text" value={ this.state.value } onChange={ (e) => this.handleOnChange(e.target.value) } onKeyDown={ (e) => this.handleOnKeyDown(e.keyCode) } placeholder="Busqueda..." />
                                </div>
                            </div>
                        </div>
                        {
                            (modalSelectorAirport.get('data').count() === 0) && this.state.value.length > 2 && !seachingAirports && (
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="alert alert-warning" role="alert">
                                            No se encontraron resultados
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        {
                            (modalSelectorAirport.get('data').count() === 0) && this.state.value.length > 2 && seachingAirports && (
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="alert alert-info" role="alert">
                                            Buscando...
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        {
                            (modalSelectorAirport.get('data').count() === 0) && this.state.value.length < 3 && (
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="alert alert-info" role="alert">
                                            Ingrese al menos 3 caracteres del nombre del aeropuerto o ciudad
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        {
                            (modalSelectorAirport.get('data').count() !== 0) && (
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div style={{ display: 'flex', justifyContent: 'center', height: '300px', overflowX: 'hidden', marginBottom: '20px', border: '1px solid #ddd' }} >
                                            <table ref={ (ref) => this.table = ref } className="table table-bordered table-condensed table-striped table-hover nowrap" style={{ marginBottom: 0 }}>
                                                <thead>
                                                    <tr>
                                                        {
                                                            modalSelectorAirport.get('fields').map((x, n) => {
                                                                return (
                                                                    <th width={ `${x.get('width')}` } key={ `th4[${n}]` }>{ x.get('caption') }</th>
                                                                )
                                                            })
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        (modalSelectorAirport.get('data').count() > 0) ? (modalSelectorAirport.get('data') || List([]))
                                                        .filter(x => {
                                                            if (modalSelectorAirport.get('filter')) {
                                                                let compare = false
                                                                modalSelectorAirport.get('fields').forEach(y => {
                                                                    compare =  compare || (x.get(`${y.get('value')}`).toLowerCase().indexOf(modalSelectorAirport.get('filter').toLowerCase()) > -1)
                                                                })
                                                                return compare
                                                            } else {
                                                                return true
                                                            }
                                                        })
                                                        .map((x, n) => {
                                                            const tds = modalSelectorAirport.get('fields').map((y, n1) => {
                                                                return (
                                                                    <td key={ `td4[${n}][${n1}]` } onMouseEnter={ e => addTitleIfOverflow(e.target) }>{ x.get(y.get('value')) }</td>
                                                                )
                                                            })
                                                            return (
                                                                <tr key={ `tr4[${n}]` } style={{ cursor: 'pointer' }} onClick={ (e) => { this.handleSelectFromSelector(e, x.toJS()) } }>
                                                                    { tds }
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                                <td colSpan={ modalSelectorAirport.get('fields').count() } style={{ textAlign: 'center' }}>
                                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '270px' }}>
                                                                        <span></span>
                                                                        <span><FontAwesome name="refresh" spin size='3x' /></span>
                                                                        <span></span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </ModalBody>
            </Modal>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalSelectorAirport: state.common.get('modalSelectorAirport'),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        hideModalSelectorAirport: () => dispatch(hideModalSelectorAirport()),
        getDataFromUrlAirports: (query) => dispatch(getDataFromUrlAirports(query)),
        clearPagesModalSelectorAirport: () => dispatch(clearPagesModalSelectorAirport()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalSelectorAirport)


// WEBPACK FOOTER //
// ./src/components/Shared/ModalSelectorAirport.jsx